/* eslint-disable no-unused-vars */
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { Toast } from 'C4';

const SideDropdown = ({
  answerOptions,
  contentComplete,
  correctAnswerText,
  disableHeader,
  disableToast,
  error,
  options,
  question,
}) => {
  const [selectedOptions, setSelectedOptions] = useState(
    answerOptions.reduce((output, { value }) => ({ ...output, [value]: -1 }), {}),
  );
  const [optionsToSelect] = useState(options.map((i) => i.value));
  const [toastContent, setToastContent] = useState(null);

  const checkAnswer = useCallback(() => {
    const correctOrder = answerOptions.reduce(
      (output, { value, correctOptionIndex }, i) => ({ ...output, [value]: correctOptionIndex }),
      {},
    );
    const allCorrect = Object.entries(correctOrder).every(([key, value]) => selectedOptions[key] === value);

    if (allCorrect) {
      setToastContent({
        position: 'bottom-center',
        content: correctAnswerText,
      });
      contentComplete();
    } else error(true);
  }, [answerOptions, contentComplete, error, selectedOptions, correctAnswerText]);

  const onSelectOption = useCallback(({ target: { value, name } }) => {
    setSelectedOptions((items) => ({ ...items, [name]: +value }));
  }, []);

  return (
    <div className="container__question sideDropDown">
      {!disableHeader && <div className="container__question--image" />}
      <div className="container__question--content">
        <h4 className="container__title">{question}</h4>
        <div className="question__cards">
          <div className="question__cards--questions">
            {answerOptions.map(({ value }, i) => (
              <h4 key={value}>{value}</h4>
            ))}
          </div>
          <div className="question__cards--options">
            {options.map(({ value }, i) => (
              <select defaultValue={-1} id={value} key={value} name={answerOptions[i].value} onChange={onSelectOption}>
                <option key="default" disabled value="-1">
                  {'Select an item below'}
                </option>
                {optionsToSelect.map((item, index) => (
                  <option key={item} value={index}>
                    {item}
                  </option>
                ))}
              </select>
            ))}
          </div>
        </div>
        {!disableToast && (
          <Toast
            trigger={toastContent !== null}
            onOpen={() => {
              setToastContent(null);
            }}
            {...toastContent}
          />
        )}
        <button type="button" onClick={checkAnswer}>
          {i18n.translate('trainingScreens.confirm')}
        </button>
      </div>
      {error(false)}
    </div>
  );
};

export default SideDropdown;

SideDropdown.propTypes = {
  answerOptions: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  correctAnswerText: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  question: PropTypes.string.isRequired,
  error: PropTypes.func,
  contentComplete: PropTypes.func.isRequired,
  disableHeader: PropTypes.bool,
  disableToast: PropTypes.bool,
};

SideDropdown.defaultProps = {
  error: () => {},
  disableHeader: false,
  disableToast: false,
};
